import { render, staticRenderFns } from "./addEvaluation.vue?vue&type=template&id=8be05a90&scoped=true&"
import script from "./addEvaluation.vue?vue&type=script&lang=js&"
export * from "./addEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./addEvaluation.vue?vue&type=style&index=0&id=8be05a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be05a90",
  null
  
)

export default component.exports